export default "__VITE_ASSET__xa_QLQ4A__"